module.exports = __webpack_public_path__ + "static/media/logo_color.8a80243e.svg";